class UnleashConfig {
  private static instance: UnleashConfig;
  public readonly config: {
    url: string;
    clientKey: string;
    appName: string;
    refreshInterval: number;
    environment: string;
  };

  private constructor() {
    const {
      REACT_APP_PUBLIC_UNLEASH_PROXY_URL = '',
      REACT_APP_PUBLIC_UNLEASH_CLIENT_KEY = '',
      REACT_APP_ENVIRONMENT = '',
    } = process.env;

    this.config = {
      url: REACT_APP_PUBLIC_UNLEASH_PROXY_URL,
      clientKey: REACT_APP_PUBLIC_UNLEASH_CLIENT_KEY,
      appName: 'PW-VIDEO-PLAYER',
      refreshInterval: 900, // seconds
      environment: REACT_APP_ENVIRONMENT,
    };
  }

  static getInstance(): UnleashConfig {
    if (!UnleashConfig.instance) {
      UnleashConfig.instance = new UnleashConfig();
    }
    return UnleashConfig.instance;
  }
}

export { UnleashConfig };
